import { mainApi } from '../config/apiClient';

// ============================================
// TYPES
// ============================================
// NOT: gts_dotnetapi default System.Text.Json camelCase property naming kullanir.
// Backend Plan 1 controller'lari `{ success, data }` wrapper'i ile yanit donder.
// Wire response: { success: true, data: [{ id, companyId, name, ... }] }

export interface KioskDto {
  id: number;
  companyId: string;
  name: string;
  branchId?: string | null;
  branchName?: string | null;
  quickSaleScreenId?: number | null;
  isActive: boolean;
}

export interface AssignKiosksToScreenPayload {
  KioskIds: number[];
  QuickSaleScreenId: number;
}

export interface UnassignKioskPayload {
  KioskId: number;
}

// ============================================
// API METHODS
// ============================================

const BASE = '/api/Kiosk';

/**
 * Backend response'u `{ success, data }` formatinda dondurur (wrapper'li).
 * Defansif olarak hem wrapper hem flat array hem PascalCase ihtimalleri ele alinir.
 */
function unwrapList<T>(raw: any): T[] {
  if (Array.isArray(raw)) return raw as T[];
  if (raw && Array.isArray(raw.data)) return raw.data as T[];
  if (raw && Array.isArray(raw.Data)) return raw.Data as T[];
  return [];
}

export const kioskAssignmentApi = {
  /**
   * Subeye bagli tum kiosklar (Kiosk Cihazlari tab'inin autocomplete kaynagi).
   */
  async getByBranch(branchId: string): Promise<KioskDto[]> {
    if (!branchId) return [];
    const { data } = await mainApi.get(`${BASE}/by-branch/${encodeURIComponent(branchId)}`);
    return unwrapList<KioskDto>(data);
  },

  /**
   * Bir hizli satis ekranina atanmis kiosklar (Kiosk Urunleri modal'i ve assignment tab chip listesi).
   */
  async getByScreen(quickSaleScreenId: number): Promise<KioskDto[]> {
    if (!quickSaleScreenId || quickSaleScreenId <= 0) return [];
    const { data } = await mainApi.get(`${BASE}/by-screen/${quickSaleScreenId}`);
    return unwrapList<KioskDto>(data);
  },

  /**
   * Multi-assign: Verilen `KioskIds` set edilir; daha once bu screen'e bagli ama
   * listede olmayan kiosklar otomatik olarak unset edilir (1:N kurali).
   */
  async assignKiosksToScreen(payload: AssignKiosksToScreenPayload): Promise<void> {
    await mainApi.post(`${BASE}/assign-screen`, payload);
  },

  /**
   * Tek bir kiosk'un screen baglantisini kaldirir (`QuickSaleScreenId = NULL`).
   */
  async unassignKiosk(payload: UnassignKioskPayload): Promise<void> {
    await mainApi.post(`${BASE}/unassign-screen`, payload);
  },
};

export default kioskAssignmentApi;
